import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {OldLeisureComponent} from './components/app.component';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule],
  declarations: [OldLeisureComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OldLeisure {}